export function parse(configStr = "", itemsGlue = ",", keyValueGlue = "=") {
    const config = {};
    const items = configStr.split(itemsGlue);

    for (const item of items) {
        const [ key, value ] = item.split(keyValueGlue);

        config[key] = typeof value !== "undefined" ? value : true;
    }

    return config;
}
